import './ProfileVersionCard.css';

export default function ProfileVersionCard({ version, onActivate, isActive }) {
  const fieldCount = (version.client_profile_fields_snapshot || []).length;
  const questionCount = (version.risk_questions_snapshot || []).length;
  const goalCount = (version.goal_templates_snapshot || []).length;
  const assetCount = (version.asset_categories_snapshot || []).length;
  const liabilityCount = (version.liability_categories_snapshot || []).length;
  const prefCount = (version.preference_templates_snapshot || []).length;

  return (
    <div className={`profile-version-card ${isActive ? 'profile-version-card--active' : ''}`}>
      <div className="profile-version-card__header">
        <div className="profile-version-card__num">v{version.version_number}</div>
        <span className={`profile-version-card__badge ${isActive ? 'profile-version-card__badge--active' : 'profile-version-card__badge--archived'}`}>
          {isActive ? 'Active' : 'Archived'}
        </span>
      </div>

      <div className="profile-version-card__meta">
        <span className="profile-version-card__tag">{version.version_tag || '(no label)'}</span>
        <span className="profile-version-card__date">
          Published {new Date(version.created_at).toLocaleDateString('en-IN')}
        </span>
      </div>

      {version.change_summary && (
        <div className="profile-version-card__summary">{version.change_summary}</div>
      )}

      <div className="profile-version-card__stats">
        <span>&#128100; {fieldCount} client fields</span>
        <span>&#10067; {questionCount} risk questions</span>
        <span>&#127919; {goalCount} goals</span>
        <span>&#128200; {assetCount} asset categories</span>
        <span>&#128203; {liabilityCount} liability categories</span>
        <span>&#9881;&#65039; {prefCount} preferences</span>
      </div>

      <div className="profile-version-card__buttons">
        <button
          className={`btn ${isActive ? 'btn--disabled' : 'btn--success'}`}
          onClick={() => !isActive && onActivate(version._id)}
          disabled={isActive}
        >
          {isActive ? 'Currently Active' : 'Activate This Version'}
        </button>
      </div>
    </div>
  );
}
